import React, { useEffect } from 'react';
import { changeColorAll } from './../CanvasActions';
import SelectField from './../Form/SelectField';

const FormP4T3 = React.memo((props) => {
    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Color"
                value={props.color}
                setFunction={props.setColor}
                options={[
                    { value: '1', label: 'Full Color' },
                    { value: '2', label: 'Full Color / Orange' },
                    { value: '3', label: 'Black and White' },
                ]}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded A6 Folded Notecard</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This folded note card fits in our A6 envelope that is available
                    in the online store. The inside of the card is blank to personalize with your message.
                </div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>6x4.5" (folded) / 6x9" (flat)</li>
                        <li>One-sided</li>
                        <li>Color</li>
                        <li>Blank inside</li>
                        <li>120# Avalanche Smooth Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP4T3;
